import type { IObjectiveProductType } from './ObjectiveProductType.interface';
import ObjectiveTypeBase from './ObjectiveTypeBase';

export default class ObjectiveProductType implements IObjectiveProductType {
  offsetAccount: ObjectiveTypeBase;
  redraw: ObjectiveTypeBase;

  static build = (data: IObjectiveProductType) => new ObjectiveProductType(data);
  static blank = () => new ObjectiveProductType();

  /**
   * Constructor
   * @param {IObjectiveProductType} data
   */
  constructor(data?: IObjectiveProductType) {
    this.offsetAccount = new ObjectiveTypeBase(data?.offsetAccount);
    this.redraw = new ObjectiveTypeBase(data?.redraw);
  }
}
